import { useSwitchFlexToWhatsappContext } from '@/feature-flags/providers/SwitchFlexToWhatsappProvider';

export function useIsFlexSwitchToWhatsappCity(ibgeCode?: string): boolean {
  const { cities } = useSwitchFlexToWhatsappContext();

  return ibgeCode ? cities.includes(ibgeCode) : false;
}
